import React, { useRef, useState } from 'react';
import TooltipPortal from './tooltip-portal';
import classNames from 'classnames';
import { isSmallViewport } from '../../Hooks/useMedia';

const CompareCareLabelTooltip = ({
  tooltipContent,
  children,
  xOffset = 0,
  label = "Mer information"
}) => {
  const [open, setOpen] = useState(false);
  const [coords, setCoords] = useState({ top: 0, left: 0 });
  const btnRef = useRef();
  const isSmallScreen = isSmallViewport();

  const showTooltip = (e) => {
    e.preventDefault();
    const rect = btnRef.current.getBoundingClientRect();
    setCoords({
      top: rect.bottom + window.scrollY + 8,
      left: isSmallScreen ? 0 : rect.left + window.scrollX + xOffset,
    });
    setOpen((prev) => !prev);
  };

  const hideTooltip = () => setOpen(false);

  return (
    <div className="compare-care__tooltip">
      <button
        className="compare-care__tooltip__button"
        ref={btnRef}
        onClick={(e) => showTooltip(e)}
        onBlur={hideTooltip}
        aria-label={ label }
      >
        {children}
        <i
          className={classNames('compare-care__tooltip__button__icon', {
            'compare-care__tooltip__button__icon--open': open === true,
          })}
        />
      </button>
      {open && (
        <TooltipPortal>
          <div
            className="compare-care__tooltip__modal"
            style={{
              top: coords.top,
              left: coords.left,
            }}
            tabIndex={-1}
            onMouseDown={(e) => e.preventDefault()}
          >
            <div className="modal__content">{tooltipContent}</div>
            <button
              className="modal__close"
              onClick={hideTooltip}
              aria-label="Stäng"
            />
          </div>
        </TooltipPortal>
      )}
    </div>
  );
};

export default CompareCareLabelTooltip;
